import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

const NOT_READY = ()=>Promise.reject('Storage not ready');

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  private _storage: Storage | null = null;
  private _cache?: globalThis.Storage;
  public ready: Promise<boolean>; // <- per si cal sincronitzar-se a l'inici

  constructor(
    private storage: Storage,
  ) {
    this.ready = this._init().then(stg=>{
      this._storage = stg;
      return Promise.resolve(true);
    }).catch((err:Error)=>{
      console.log("StorageService failed to init", err);
      return Promise.reject(err)
    });
  }

  private async _init() {
    // inicialitza la caché
    if(!!this.storageAvailable('sessionStorage')) this._cache = window.sessionStorage;
    // If using, define drivers here: await this.storage.defineDriver(/*...*/);
    return await this.storage.create();
  }

  private storageAvailable(type: 'localStorage' | 'sessionStorage') {
    let storage;
    try {
      storage = window[type];
      const x = "__storage_test__";
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return (
        e instanceof DOMException &&
        e.name === "QuotaExceededError" &&
        // acknowledge QuotaExceededError only if there's something already stored
        storage &&
        storage.length !== 0
      );
    }
  }

  // Publica part de l'API del _storage

  public set(key: string, value: any) {
    if (!this._storage) return NOT_READY();
    return this._storage.set(key, value);
  }

  public get(key:string) {
    if (!this._storage) return NOT_READY();
    return this._storage.get(key); 
  }

  public remove(key:string) {
    if (!this._storage) return NOT_READY();
    return this._storage.remove(key); 
  }

  public keys() {
    if (!this._storage) return NOT_READY();
    return this._storage.keys();
  }

  // Métodes per desar dades en caché a la sessionStorage

  public setCache(key: string, value: any) {
    if (!this._cache) throw new Error('sessionStorage not available');
    if (!value) return this._cache.removeItem(key);
    const serial = JSON.stringify({ ts: Date.now(), value });
    this._cache.setItem(key, serial);
  }

  // per defecte 3h de caché (timeout)
  public getCache(key: string, timeout=1000*60*60*3) {
    if (!this._cache) throw new Error('sessionStorage not available');
    const serial = this._cache.getItem(key);
    if (!serial) return undefined;
    const { ts, value } = JSON.parse(serial);
    if (timeout>0 && ts + timeout < Date.now()) {
      this._cache.removeItem(key);
      return undefined;
    }
    return value; 
  }

  // Neteja la caché
  public clearCache() {
    if (!this._cache) throw new Error('sessionStorage not available');
    this._cache.clear();
  }

}
